import angular from 'angular'

import component from './device-content.component'

let module = angular.module('deviceContent', [])

.component('deviceContent', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/device-content/index.js